import React, { useState } from 'react';
import styled from '@emotion/styled';
import Modal, { ModalTransition } from '@atlaskit/modal-dialog';
import Button from '@atlaskit/button';
import { FailureProductRowsContainer } from './failure-product-rows-container';
import { useProductLineItemsForOrderFailureStore } from '../../../../../../store';

export interface FailureItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  failureItemIds: string[];
}

const StyledBillingProfilePONumberActions = styled.div({
  display: 'flex',
  justifyContent: 'end',
  gap: '8px',
  padding: '20px',
});

export const FailureItemModal = ({ isOpen, onClose, failureItemIds }: FailureItemModalProps) => {
  const [failureProductLineItems] = useProductLineItemsForOrderFailureStore({
    failureItemIds: failureItemIds,
  });

  //creating an array of all products
  const products = failureProductLineItems
    .map((lineItem) => lineItem.products)
    .reduce((acc, val) => acc.concat(val), []);

  return (
    <ModalTransition>
      {isOpen && (
        <Modal onClose={onClose} shouldCloseOnOverlayClick={false} shouldScrollInViewport width={'x-large'}>
          <FailureProductRowsContainer products={products} />
          <StyledBillingProfilePONumberActions>
            <Button onClick={onClose}>close</Button>
          </StyledBillingProfilePONumberActions>
        </Modal>
      )}
    </ModalTransition>
  );
};
